import { Component, ViewChild } from '@angular/core';
import { DxPopupComponent } from 'devextreme-angular/ui/popup';
import { lastValueFrom, Subscription } from 'rxjs';
import { PopupService } from '../../services/popup.service';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from '../../services/api.service';
import { ConfigService } from '../../services/config.service';
import { DxFormComponent } from 'devextreme-angular';

// interface IFormData {
//   berechnungsMonatVon: string;
//   berechnungsMonatBis: string;
//   betragTyp: number;
//   // jahr: number;
//   // monat: number;
// }

@Component({
  selector: 'app-bgb-stapelberechnung-dialog',
  templateUrl: './bgb-stapelberechnung-dialog.component.html',
  styleUrls: ['./bgb-stapelberechnung-dialog.component.scss'],
  standalone: false,
})
export class BgbStapelberechnungDialogComponent {
  @ViewChild('popup', { static: false }) popup: DxPopupComponent;
  @ViewChild('editForm', { static: false }) editForm: DxFormComponent;

  subscription_get_PopupAsObservable: Subscription;

  onClose: (e) => void;

  formData: any; //IFormData;
  isLoading: boolean = false;
  isError: boolean = false;
  isBerechnet: boolean = false;
  errorText: string = '';
  beitragsArten: any = null;

  constructor(private popupService: PopupService, private apiService: ApiService, private configService: ConfigService) {
    this.onClickClose = this.onClickClose.bind(this);
    this.onClickStart = this.onClickStart.bind(this);
    this.onChangeDatumVon = this.onChangeDatumVon.bind(this);

    const _akt_Datum = configService.berechnungsDatum !== null ? this.configService.berechnungsDatum.toISOString() : new Date().toISOString();
    this.formData = {
      berechnungsMonatVon: _akt_Datum,
      berechnungsMonatBis: _akt_Datum,
      // beitragsArt: null,
      beitragsArten: null,
    };

    this.subscription_get_PopupAsObservable = this.popupService.get_stapelBerechnungPopupAsObservable.subscribe((context) => {
      if (context !== null && context !== undefined && context.open === true) {
        this.isBerechnet = false;
        this.isError = false;
        this.isLoading = false;
        this.popup.instance.show();
      }
    });
  }

  onShown(e) {
    const _avialableBeitragarten = this.configService.getAvialableBeitragsArten();
    if (_avialableBeitragarten !== null && _avialableBeitragarten !== undefined) {
      this.beitragsArten = _avialableBeitragarten.filter((x) => x.key !== 2); // Außer Essengeldabrechnung
    }
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    if (this.subscription_get_PopupAsObservable) {
      this.subscription_get_PopupAsObservable.unsubscribe();
    }
  }

  onClickClose() {
    this.popup.instance.hide();
  }

  onHidden(e) {
    this.formData.beitragsArten = null;
  }

  onClickStart() {
    setTimeout(() => {
      if (this.isLoading === true) {
        this.isError = true;
        this.isLoading = false;
        this.isBerechnet = false;
        this.errorText = 'Time out überschritten!';
      }
    }, 15000);

    const validationResult = this.editForm.instance.validate();
    if (validationResult.isValid && this.formData.berechnungsMonatVon !== undefined) {
      this.isBerechnet = false;
      this.isError = false;
      this.isLoading = true;

      const toSend = {
        datumVon: new Date(this.formData.berechnungsMonatVon).toDateString(),
        datumBis: new Date(this.formData.berechnungsMonatBis).toDateString(),
        beitragsArten: this.formData.beitragsArten,
      };

      this.apiService.post<any>(RouteKeys.Bgb.elternbeitrag_stapelberechnung, toSend).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.isBerechnet = true;
        },
        error: (err) => {
          this.isError = true;
          this.isLoading = false;
          this.isBerechnet = false;
          this.errorText = err.message;
          throw err;
        },
      });
    }
  }

  onChangeDatumVon(e) {
    if (e.value > this.formData.berechnungsMonatBis) {
      this.formData.berechnungsMonatBis = e.value;
    }
  }
}
